import { AutocompleteTextField } from 'hic-components'
import { useEffect, useMemo, useState } from 'react'
import { IdentificationDocumentFragment, useIdentificationDocumentsQuery } from 'src/api/api.generated'
import useLocalizeString from 'src/app/hooks/current-locale/use-localized-string'

export type DocumentSelectProps = {
  value: string | null
  onChange: (value: string | null) => void
  error?: boolean
  disabled?: boolean
  size?: 'small' | 'medium'
}

export default function DocumentSelect({ value, onChange, error, disabled, size }: DocumentSelectProps) {
  const { data } = useIdentificationDocumentsQuery({ fetchPolicy: 'cache-first' })
  const localizeString = useLocalizeString()

  const options = useMemo(() => data?.identificationDocuments ?? [], [data])

  const [localValue, setLocalValue] = useState<IdentificationDocumentFragment | null>(null)

  useEffect(() => {
    if (data) {
      const nlv = (data?.identificationDocuments ?? []).find((c) => c.id === value) ?? null
      const nlvId = nlv?.id ?? null
      if (JSON.stringify(nlv) !== JSON.stringify(localValue)) {
        setLocalValue(nlv)
      }
      if (nlvId !== value) {
        onChange(nlvId)
      }
    }
  }, [data, value])

  return (
    <AutocompleteTextField<IdentificationDocumentFragment> //
      size={size}
      getOptionLabel={(option) => localizeString(option.name)}
      disabled={disabled}
      options={options}
      value={localValue}
      onChange={(doc) => onChange(doc?.id ?? null)}
      error={error}
    />
  )
}
